import React, {useState, useEffect} from 'react';
import {
  Select,
  MenuItem,
  Chip,
  Box,
  CircularProgress,
  OutlinedInput,
  Checkbox,
  ListItemText,
} from '@mui/material';
import {Axios} from 'services/axios';

const PageSelector = ({value, onChange, countryId, multiple = true}) => {
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(false);

  const normalizeId = id => (id == null ? id : String(id));
  const safeValue = (Array.isArray(value) ? value : []).map(normalizeId);

  useEffect(() => {
    const fetchPages = async () => {
      try {
        setLoading(true);
        const response = await Axios.fetch('page/list', {
          params: {
            countryId: countryId,
            limit: 100,
          },
        });

        const pagesData =
          response.data?.data?.pages || response.data?.pages || [];
        setPages(pagesData);
      } catch (error) {
        console.error('Error fetching pages:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPages();
  }, [countryId]);

  const handleChange = nextValue => {
    const next = Array.isArray(nextValue) ? nextValue : [nextValue];
    onChange(next.map(normalizeId).filter(Boolean));
  };

  if (loading) return <CircularProgress size={24} />;

  return (
    <Select
      multiple={multiple}
      displayEmpty
      value={safeValue}
      onChange={e => handleChange(e.target.value)}
      input={<OutlinedInput label="Select Pages" />}
      renderValue={selected => {
        if (!selected?.length) {
          return (
            <Box component="span" sx={{color: 'text.secondary'}}>
              Select pages
            </Box>
          );
        }
        return (
          <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 0.5}}>
            {selected.map(pageId => {
              const page = pages.find(
                p => normalizeId(p.id) === normalizeId(pageId),
              );
              return (
                <Chip
                  key={pageId}
                  label={page?.name || pageId}
                  size="small"
                />
              );
            })}
          </Box>
        );
      }}>
      {pages.length === 0 && (
        <MenuItem disabled value="">
          <ListItemText primary="No pages found" />
        </MenuItem>
      )}
      {pages.map(page => (
        <MenuItem key={page.id} value={normalizeId(page.id)}>
          <Checkbox checked={safeValue.indexOf(normalizeId(page.id)) > -1} />
          <ListItemText primary={page.name} secondary={page.route} />
        </MenuItem>
      ))}
    </Select>
  );
};

export default PageSelector;
